webpackJsonp([263791100135453],{

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/me.cb320835.jpg";

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _me = __webpack_require__(533);
	
	var _me2 = _interopRequireDefault(_me);
	
	var _typography = __webpack_require__(19);
	
	var _reactHelmet = __webpack_require__(87);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About() {
	  return Glamor.createElement(
	    'div',
	    null,
	    Glamor.createElement(_reactHelmet2.default, { title: 'About Armando Sosa' }),
	    Glamor.createElement(
	      'h1',
	      {
	        css: {
	          textAlign: 'center',
	          fontSize: (0, _typography.rhythm)(3),
	          marginBottom: (0, _typography.rhythm)(1),
	          color: 'tomato'
	        }
	      },
	      'About Me'
	    ),
	    Glamor.createElement(
	      'div',
	      null,
	      Glamor.createElement('img', {
	        src: _me2.default,
	        css: {
	          width: '200px',
	          float: 'left',
	          margin: '22px',
	          marginTop: '11px',
	          borderRadius: '11px'
	        }
	      }),
	      Glamor.createElement(
	        'div',
	        { css: { paddingLeft: '120px', paddingRight: '120px' } },
	        Glamor.createElement(
	          'p',
	          null,
	          'Hello! My full name is ',
	          Glamor.createElement(
	            'em',
	            null,
	            'Armando Quetzalcoatl Sosa Garay'
	          ),
	          ', but my friends just call me ',
	          Glamor.createElement(
	            'strong',
	            null,
	            'Armando'
	          ),
	          '. All three of them.'
	        ),
	        Glamor.createElement(
	          'p',
	          null,
	          'I\'m a small mexican dude who has been doing internet stuff for what feels like an eternity. I used to be a graphic designer but, fun fact: that\'s the worst paid profession in Mexico, so I pivoted to programming and I\'ve been doing a lot better.'
	        ),
	        Glamor.createElement(
	          'p',
	          null,
	          'When I am not in front of a computer you may find me attending church, playing music, or just hanging out with my wonderful wife.'
	        ),
	        Glamor.createElement(
	          'p',
	          null,
	          'I am a type-2 diabetic, which sucks because eating is my favorite hobby. Look, it\'s not my fault that I live in the country with the best food in the ',
	          Glamor.createElement(
	            'del',
	            null,
	            'world'
	          ),
	          ' universe.'
	        ),
	        Glamor.createElement(
	          'p',
	          null,
	          'I\'ve been working as a remote front-end engineer since 2009 for companies in New York, San Francisco, and Colombia. Currently I am eployed by ',
	          Glamor.createElement(
	            'a',
	            { href: 'https://paidlabs.com' },
	            'Paid Labs'
	          ),
	          ' as a React Developer.'
	        ),
	        Glamor.createElement(
	          'p',
	          null,
	          '\u2026And I think I\'ll stop with my rambling. If you want to know more, you can ',
	          Glamor.createElement(
	            'a',
	            { href: '#' },
	            'follow me on twitter'
	          ),
	          ' or send me an electronic letter to ',
	          Glamor.createElement(
	            'em',
	            null,
	            'arm.sosa[at]gmail.com.'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = About;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-6ba9a3012b7547f885fd.js